import React from "react";

import { Alert, EmailConfirm } from "../components";

const OfferConfirmation = () => {
  return (
    <EmailConfirm>
      <Alert
        type="success"
        message={"THANK YOU FOR ACCEPTING THE OFFER!"}
        description={"We will reach out to you on the next step."}
      />
    </EmailConfirm>
  );
};

export default OfferConfirmation;
